import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';

export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();
  const originalLink = MarkedRenderer.prototype.link;

  renderer.link = function (this: MarkedRenderer, linkData: any): string {
    const html = originalLink.call(this, linkData);
    return html.replace(/^<a /, '<a target="_blank" rel="nofollow noopener noreferrer" ');
  } as MarkedRenderer['link'];

  return { renderer };
}
